import logo from './logo.svg';
import './App.css';
import { createContext, useState } from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import "react-toastify/dist/ReactToastify.css";
import LandingPage from './compound/LandingPage';
import Login from './compound/Login';
import Donate from './compound/Donate';
import SuperAdminDashboard from './compound/SuperAdmin/SuperAdminDashboard';
import Branches from './compound/SuperAdmin/Branches';
import Admins from './compound/SuperAdmin/Admins';
import AddBranches from './compound/SuperAdmin/AddBranches';
import AllBranches from './compound/SuperAdmin/AllBranches';
import AddAdmins from './compound/SuperAdmin/AddAdmins';
import AllAdmins from './compound/SuperAdmin/AllAdmins';
import EditBranch from './compound/SuperAdmin/EditBranch';
import AssignBranch from './compound/SuperAdmin/AssignBranch';
import EditAdmin from './compound/SuperAdmin/EditAdmin';
import AdminDashboard from './compound/Admin/AdminDashboard';
import Staff from './compound/Admin/Staff';
import AddStaff from './compound/Admin/AddStaff';
import StaffOverview from './compound/Admin/StaffOverview';
import AllStaffs from './compound/Admin/AllStaffs';
import Department from './compound/Admin/Department';
import AddDepartment from './compound/Admin/AddDepartment';
import AllDepartments from './compound/Admin/AllDepartments';
import EditDepartment from './compound/Admin/EditDepartment';
import PendingBranchAllocation from './compound/SuperAdmin/PendingBranchAllocation';
import AllocatedBranches from './compound/SuperAdmin/AllocatedBranches';
import EditStaff from './compound/Admin/EditStaff';
import NewAdmissions from './compound/Admin/NewAdmissions';
import AddNewAdmission from './compound/Admin/AddNewAdmission';
import AllNewAdmissions from './compound/Admin/AllNewAdmissions';
import NewAdmissionOverview from './compound/Admin/NewAdmissionOverview';
import EditNewAdmission from './compound/Admin/EditNewAdmission';
import DonationEnquiries from './compound/Admin/DonationEnquiries';
import TelecallerDashboard from './compound/Telecaller/TelecallerDashboard';
import TelecallerDonationEnquiry from './compound/Telecaller/TelecallerDonationEnquiry';
import PendingEnquiries from './compound/Admin/PendingEnquiries';
import AssignedEnquiries from './compound/Admin/AssignedEnquiries';
import ManagerDashboard from './compound/Manager/ManagerDashboard';
import AllBedList from './compound/Manager/AllBedList';
import AddBeds from './compound/Manager/AddBeds';
import Beds from './compound/Manager/Beds';
import AllocateBeds from './compound/Manager/AllocateBeds';
import AddAllocateBed from './compound/Manager/AddAllocateBed';
import AllAllocateBed from './compound/Manager/AllAllocateBed';
import EditAllocatedBed from './compound/Manager/EditAllocatedBed';

export const sidebarContext = createContext()

function App() {
  const [hs, setHS] = useState(false)

  return (
    <div className="App">
      <ToastContainer position='top-right' autoClose={1000}/>
      <sidebarContext.Provider value={{hs, setHS}}>
        <Router>
          <Routes>
            <Route path='/' element={<LandingPage/>}/>
            <Route path='/login' element={<Login/>}/>
            <Route path='/donation' element={<Donate/>}/>

            <Route path='/super_admin/super_admin_dashboard' element={<SuperAdminDashboard/>}/>
    
            <Route path='/super_admin/branch' element={<Branches/>}/>
            <Route path='/super_admin/add_branch' element={<AddBranches/>}/>
            <Route path='/super_admin/all_branches' element={<AllBranches/>}/>
            <Route path='/super_admin/pending_branch_allocation' element={<PendingBranchAllocation/>}/>
            <Route path='/super_admin/allocated_branches' element={<AllocatedBranches/>}/>
            <Route path='/super_admin/edit_branch/:id' element={<EditBranch/>}/>
            <Route path='/super_admin/assign_branch/:id' element={<AssignBranch/>}/>

            <Route path='/super_admin/admin' element={<Admins/>}/>
            <Route path='/super_admin/add_admin' element={<AddAdmins/>}/>
            <Route path='/super_admin/all_admins' element={<AllAdmins/>}/>
            <Route path='/super_admin/edit_admin/:id' element={<EditAdmin/>}/>

            <Route path='/admin/admin_dashboard' element={<AdminDashboard/>}/>
            <Route path='/admin/staffs' element={<Staff/>}/>
            <Route path='/admin/add_staff' element={<AddStaff/>}/>
            <Route path='/admin/all_staffs' element={<AllStaffs/>}/>
            <Route path='/admin/staff_overview/:id' element={<StaffOverview/>}/>
            <Route path='/admin/edit_staff/:id' element={<EditStaff/>}/>

            <Route path='/admin/departments' element={<Department/>}/>
            <Route path='/admin/add_department' element={<AddDepartment/>}/>
            <Route path='/admin/all_departments' element={<AllDepartments/>}/>
            <Route path='/admin/edit_department/:id' element={<EditDepartment/>}/>

            <Route path='/admin/new_admissions' element={<NewAdmissions/>}/>
            <Route path='/admin/add_new_admission' element={<AddNewAdmission/>}/>
            <Route path='/admin/all_new_admissions' element={<AllNewAdmissions/>}/>
            <Route path='/admin/new_admission_overview/:id' element={<NewAdmissionOverview/>}/>
            <Route path='/admin/edit_new_admission/:id' element={<EditNewAdmission/>}/>
            <Route path='/admin/donation_enquiries' element={<DonationEnquiries/>}/>
            <Route path='/admin/pending_enquiries' element={<PendingEnquiries/>}/>
            <Route path='/admin/assigned_enquiries' element={<AssignedEnquiries/>}/>

            <Route path='/telecaller/telecaller_dashboard' element={<TelecallerDashboard/>}/>
            <Route path='/telecaller/telecaller_donation_enquiry' element={<TelecallerDonationEnquiry/>}/>

            <Route path='/manager/manager_dashboard' element={<ManagerDashboard/>}/>
            <Route path='/manager/beds' element={<Beds/>}/>
            <Route path='/manager/add_bed' element={<AddBeds/>}/>
            <Route path='/manager/all_beds' element={<AllBedList/>}/>
            <Route path='/manager/allocate_bed' element={<AllocateBeds/>}/>
            <Route path='/manager/add_allocate_bed' element={<AddAllocateBed/>}/>
            <Route path='/manager/all_allocate_bed' element={<AllAllocateBed/>}/>
            <Route path='/manager/edit_allocated_bed/:id' element={<EditAllocatedBed/>}/>

            <Route path='/accounts/accounts_dashboard' element={<ManagerDashboard/>}/>


          </Routes>
        </Router>
      </sidebarContext.Provider>
    </div>
  );
}

export default App;
